import React from 'react';
import { IonSlides, IonSlide } from '@ionic/react';

import './ExploreContainer.css';

interface ContainerProps { }

// Optional parameters to pass to the swiper instance.
// See http://idangero.us/swiper/api/ for valid options.
const slideOpts = {
  initialSlide: 0,
  speed: 400
};

const slides = [
  {
    key: 2,
    image: 'assets/images/menu-02-aperitivi.jpeg',
    description: 'aperitivi'
  },
  {
    key: 3,
    image: 'assets/images/menu-03-vini.jpeg',
    description: 'i nostri vini'
  },
  {
    key: 4,
    image: 'assets/images/menu-04-caffetteria.jpeg',
    description: 'caffetteria'
  },
  {
    key: 5,
    image: 'assets/images/menu-05-cibo.jpeg',
    description: 'taglieri, panini e insalate'
  },
  {
    key: 6,
    image: 'assets/images/menu-06-cocktails.jpeg',
    description: 'cocktails'
  }
]

const ExploreContainer: React.FC<ContainerProps> = () => {
  return (
      <div>
        <IonSlides pager={true} options={slideOpts}>
          {
            slides.map(element => {
              return(
                <IonSlide key={element.key}>
                  <img src={element.image} alt={element.description} />
                </IonSlide>
              );
            })
          }
        </IonSlides>
      </div>
    );
};

export default ExploreContainer;
